export default "__VITE_ASSET__Dr$TKdr6__"